module.exports = __webpack_public_path__ + "img/convenience-7-image.e78f5ee8.jpg";